function de(A) {
  return A && A.__esModule && Object.prototype.hasOwnProperty.call(A, 'default') ? A.default : A;
}
var et = { exports: {} },
  ge = et.exports,
  en;
function xe() {
  return (
    en ||
      ((en = 1),
      (function (A, S) {
        (function (H, I) {
          A.exports = I();
        })(ge, function () {
          function H(t, n) {
            if (!(t instanceof n)) throw new TypeError('Cannot call a class as a function');
          }
          function I(t, n) {
            return rn(t) || fn(t, n) || _t(t, n) || un();
          }
          function rt(t) {
            return it(t) || an(t) || _t(t) || on();
          }
          function it(t) {
            if (Array.isArray(t)) return at(t);
          }
          function rn(t) {
            if (Array.isArray(t)) return t;
          }
          function an(t) {
            if (typeof Symbol < 'u' && Symbol.iterator in Object(t)) return Array.from(t);
          }
          function fn(t, n) {
            if (!(typeof Symbol > 'u' || !(Symbol.iterator in Object(t)))) {
              var e = [],
                r = !0,
                i = !1,
                a = void 0;
              try {
                for (
                  var f = t[Symbol.iterator](), o;
                  !(r = (o = f.next()).done) && (e.push(o.value), !(n && e.length === n));
                  r = !0
                );
              } catch (u) {
                (i = !0), (a = u);
              } finally {
                try {
                  !r && f.return != null && f.return();
                } finally {
                  if (i) throw a;
                }
              }
              return e;
            }
          }
          function _t(t, n) {
            if (t) {
              if (typeof t == 'string') return at(t, n);
              var e = Object.prototype.toString.call(t).slice(8, -1);
              if ((e === 'Object' && t.constructor && (e = t.constructor.name), e === 'Map' || e === 'Set'))
                return Array.from(e);
              if (e === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return at(t, n);
            }
          }
          function at(t, n) {
            (n == null || n > t.length) && (n = t.length);
            for (var e = 0, r = new Array(n); e < n; e++) r[e] = t[e];
            return r;
          }
          function on() {
            throw new TypeError(`Invalid attempt to spread non-iterable instance.
    In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }
          function un() {
            throw new TypeError(`Invalid attempt to destructure non-iterable instance.
    In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }
          var ft = Math.PI,
            ot = 2 * ft,
            P = 1e-6,
            sn = ot - P;
          function ut() {
            (this._x0 = this._y0 = this._x1 = this._y1 = null), (this._ = '');
          }
          function Nt() {
            return new ut();
          }
          ut.prototype = Nt.prototype = {
            constructor: ut,
            moveTo: function (t, n) {
              this._ += 'M' + (this._x0 = this._x1 = +t) + ',' + (this._y0 = this._y1 = +n);
            },
            closePath: function () {
              this._x1 !== null && ((this._x1 = this._x0), (this._y1 = this._y0), (this._ += 'Z'));
            },
            lineTo: function (t, n) {
              this._ += 'L' + (this._x1 = +t) + ',' + (this._y1 = +n);
            },
            quadraticCurveTo: function (t, n, e, r) {
              this._ += 'Q' + +t + ',' + +n + ',' + (this._x1 = +e) + ',' + (this._y1 = +r);
            },
            bezierCurveTo: function (t, n, e, r, i, a) {
              this._ += 'C' + +t + ',' + +n + ',' + +e + ',' + +r + ',' + (this._x1 = +i) + ',' + (this._y1 = +a);
            },
            arcTo: function (t, n, e, r, i) {
              (t = +t), (n = +n), (e = +e), (r = +r), (i = +i);
              var a = this._x1,
                f = this._y1,
                o = e - t,
                u = r - n,
                d = a - t,
                c = f - n,
                s = d * d + c * c;
              if (i < 0) throw new Error('negative radius: ' + i);
              if (this._x1 === null) this._ += 'M' + (this._x1 = t) + ',' + (this._y1 = n);
              else if (s > P)
                if (!(Math.abs(c * o - u * d) > P) || !i) this._ += 'L' + (this._x1 = t) + ',' + (this._y1 = n);
                else {
                  var h = e - a,
                    y = r - f,
                    x = o * o + u * u,
                    m = h * h + y * y,
                    M = Math.sqrt(x),
                    k = Math.sqrt(s),
                    E = i * Math.tan((ft - Math.acos((x + s - m) / (2 * M * k))) / 2),
                    b = E / k,
                    $ = E / M;
                  Math.abs(b - 1) > P && (this._ += 'L' + (t + b * d) + ',' + (n + b * c)),
                    (this._ +=
                      'A' +
                      i +
                      ',' +
                      i +
                      ',0,0,' +
                      +(c * h > d * y) +
                      ',' +
                      (this._x1 = t + $ * o) +
                      ',' +
                      (this._y1 = n + $ * u));
                }
            },
            arc: function (t, n, e, r, i, a) {
              (t = +t), (n = +n), (e = +e), (a = !!a);
              var f = e * Math.cos(r),
                o = e * Math.sin(r),
                u = t + f,
                d = n + o,
                c = 1 ^ a,
                s = a ? r - i : i - r;
              if (e < 0) throw new Error('negative radius: ' + e);
              this._x1 === null
                ? (this._ += 'M' + u + ',' + d)
                : (Math.abs(this._x1 - u) > P || Math.abs(this._y1 - d) > P) && (this._ += 'L' + u + ',' + d),
                e &&
                  (s < 0 && (s = (s % ot) + ot),
                  s > sn
                    ? (this._ +=
                        'A' +
                        e +
                        ',' +
                        e +
                        ',0,1,' +
                        c +
                        ',' +
                        (t - f) +
                        ',' +
                        (n - o) +
                        'A' +
                        e +
                        ',' +
                        e +
                        ',0,1,' +
                        c +
                        ',' +
                        (this._x1 = u) +
                        ',' +
                        (this._y1 = d))
                    : s > P &&
                      (this._ +=
                        'A' +
                        e +
                        ',' +
                        e +
                        ',0,' +
                        +(s >= ft) +
                        ',' +
                        c +
                        ',' +
                        (this._x1 = t + e * Math.cos(i)) +
                        ',' +
                        (this._y1 = n + e * Math.sin(i))));
            },
            rect: function (t, n, e, r) {
              this._ +=
                'M' +
                (this._x0 = this._x1 = +t) +
                ',' +
                (this._y0 = this._y1 = +n) +
                'h' +
                +e +
                'v' +
                +r +
                'h' +
                -e +
                'Z';
            },
            toString: function () {
              return this._;
            },
          };
          function G(t) {
            return function () {
              return t;
            };
          }
          function kt(t) {
            this._context = t;
          }
          kt.prototype = {
            areaStart: function () {
              this._line = 0;
            },
            areaEnd: function () {
              this._line = NaN;
            },
            lineStart: function () {
              this._point = 0;
            },
            lineEnd: function () {
              (this._line || (this._line !== 0 && this._point === 1)) && this._context.closePath(),
                (this._line = 1 - this._line);
            },
            point: function (t, n) {
              switch (((t = +t), (n = +n), this._point)) {
                case 0:
                  (this._point = 1), this._line ? this._context.lineTo(t, n) : this._context.moveTo(t, n);
                  break;
                case 1:
                  this._point = 2;
                default:
                  this._context.lineTo(t, n);
                  break;
              }
            },
          };
          function hn(t) {
            return new kt(t);
          }
          function cn(t) {
            return t[0];
          }
          function ln(t) {
            return t[1];
          }
          function dn() {
            var t = cn,
              n = ln,
              e = G(!0),
              r = null,
              i = hn,
              a = null;
            function f(o) {
              var u,
                d = o.length,
                c,
                s = !1,
                h;
              for (r == null && (a = i((h = Nt()))), u = 0; u <= d; ++u)
                !(u < d && e((c = o[u]), u, o)) === s && ((s = !s) ? a.lineStart() : a.lineEnd()),
                  s && a.point(+t(c, u, o), +n(c, u, o));
              if (h) return (a = null), h + '' || null;
            }
            return (
              (f.x = function (o) {
                return arguments.length ? ((t = typeof o == 'function' ? o : G(+o)), f) : t;
              }),
              (f.y = function (o) {
                return arguments.length ? ((n = typeof o == 'function' ? o : G(+o)), f) : n;
              }),
              (f.defined = function (o) {
                return arguments.length ? ((e = typeof o == 'function' ? o : G(!!o)), f) : e;
              }),
              (f.curve = function (o) {
                return arguments.length ? ((i = o), r != null && (a = i(r)), f) : i;
              }),
              (f.context = function (o) {
                return arguments.length ? (o == null ? (r = a = null) : (a = i((r = o))), f) : r;
              }),
              f
            );
          }
          function At(t, n) {
            return t < n ? -1 : t > n ? 1 : t >= n ? 0 : NaN;
          }
          function gn(t) {
            return (
              t.length === 1 && (t = xn(t)),
              {
                left: function (n, e, r, i) {
                  for (r == null && (r = 0), i == null && (i = n.length); r < i; ) {
                    var a = (r + i) >>> 1;
                    t(n[a], e) < 0 ? (r = a + 1) : (i = a);
                  }
                  return r;
                },
                right: function (n, e, r, i) {
                  for (r == null && (r = 0), i == null && (i = n.length); r < i; ) {
                    var a = (r + i) >>> 1;
                    t(n[a], e) > 0 ? (i = a) : (r = a + 1);
                  }
                  return r;
                },
              }
            );
          }
          function xn(t) {
            return function (n, e) {
              return At(t(n), e);
            };
          }
          var mn = gn(At),
            pn = mn.right,
            st = Math.sqrt(50),
            ht = Math.sqrt(10),
            ct = Math.sqrt(2);
          function yn(t, n, e) {
            var r,
              i = -1,
              a,
              f,
              o;
            if (((n = +n), (t = +t), (e = +e), t === n && e > 0)) return [t];
            if (((r = n < t) && ((a = t), (t = n), (n = a)), (o = V(t, n, e)) === 0 || !isFinite(o))) return [];
            if (o > 0)
              for (t = Math.ceil(t / o), n = Math.floor(n / o), f = new Array((a = Math.ceil(n - t + 1))); ++i < a; )
                f[i] = (t + i) * o;
            else
              for (t = Math.floor(t * o), n = Math.ceil(n * o), f = new Array((a = Math.ceil(t - n + 1))); ++i < a; )
                f[i] = (t - i) / o;
            return r && f.reverse(), f;
          }
          function V(t, n, e) {
            var r = (n - t) / Math.max(0, e),
              i = Math.floor(Math.log(r) / Math.LN10),
              a = r / Math.pow(10, i);
            return i >= 0
              ? (a >= st ? 10 : a >= ht ? 5 : a >= ct ? 2 : 1) * Math.pow(10, i)
              : -Math.pow(10, -i) / (a >= st ? 10 : a >= ht ? 5 : a >= ct ? 2 : 1);
          }
          function bn(t, n, e) {
            var r = Math.abs(n - t) / Math.max(0, e),
              i = Math.pow(10, Math.floor(Math.log(r) / Math.LN10)),
              a = r / i;
            return a >= st ? (i *= 10) : a >= ht ? (i *= 5) : a >= ct && (i *= 2), n < t ? -i : i;
          }
          function vn(t, n) {
            switch (arguments.length) {
              case 0:
                break;
              case 1:
                this.range(t);
                break;
              default:
                this.range(n).domain(t);
                break;
            }
            return this;
          }
          var v = '$';
          function X() {}
          X.prototype = St.prototype = {
            constructor: X,
            has: function (t) {
              return v + t in this;
            },
            get: function (t) {
              return this[v + t];
            },
            set: function (t, n) {
              return (this[v + t] = n), this;
            },
            remove: function (t) {
              var n = v + t;
              return n in this && delete this[n];
            },
            clear: function () {
              for (var t in this) t[0] === v && delete this[t];
            },
            keys: function () {
              var t = [];
              for (var n in this) n[0] === v && t.push(n.slice(1));
              return t;
            },
            values: function () {
              var t = [];
              for (var n in this) n[0] === v && t.push(this[n]);
              return t;
            },
            entries: function () {
              var t = [];
              for (var n in this) n[0] === v && t.push({ key: n.slice(1), value: this[n] });
              return t;
            },
            size: function () {
              var t = 0;
              for (var n in this) n[0] === v && ++t;
              return t;
            },
            empty: function () {
              for (var t in this) if (t[0] === v) return !1;
              return !0;
            },
            each: function (t) {
              for (var n in this) n[0] === v && t(this[n], n.slice(1), this);
            },
          };
          function St(t, n) {
            var e = new X();
            if (t instanceof X)
              t.each(function (o, u) {
                e.set(u, o);
              });
            else if (Array.isArray(t)) {
              var r = -1,
                i = t.length,
                a;
              if (n == null) for (; ++r < i; ) e.set(r, t[r]);
              else for (; ++r < i; ) e.set(n((a = t[r]), r, t), a);
            } else if (t) for (var f in t) e.set(f, t[f]);
            return e;
          }
          function Rt() {}
          var T = St.prototype;
          Rt.prototype = {
            constructor: Rt,
            has: T.has,
            add: function (t) {
              return (t += ''), (this[v + t] = t), this;
            },
            remove: T.remove,
            clear: T.clear,
            values: T.keys,
            size: T.size,
            empty: T.empty,
            each: T.each,
          };
          var Et = Array.prototype,
            wn = Et.map,
            Pt = Et.slice;
          function lt(t, n, e) {
            (t.prototype = n.prototype = e), (e.constructor = t);
          }
          function Tt(t, n) {
            var e = Object.create(t.prototype);
            for (var r in n) e[r] = n[r];
            return e;
          }
          function j() {}
          var F = 0.7,
            Z = 1 / F,
            z = '\\s*([+-]?\\d+)\\s*',
            D = '\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*',
            _ = '\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*',
            Mn = /^#([0-9a-f]{3,8})$/,
            _n = new RegExp('^rgb\\(' + [z, z, z] + '\\)$'),
            Nn = new RegExp('^rgb\\(' + [_, _, _] + '\\)$'),
            kn = new RegExp('^rgba\\(' + [z, z, z, D] + '\\)$'),
            An = new RegExp('^rgba\\(' + [_, _, _, D] + '\\)$'),
            Sn = new RegExp('^hsl\\(' + [D, _, _] + '\\)$'),
            Rn = new RegExp('^hsla\\(' + [D, _, _, D] + '\\)$'),
            $t = {
              aliceblue: 15792383,
              antiquewhite: 16444375,
              aqua: 65535,
              aquamarine: 8388564,
              azure: 15794175,
              beige: 16119260,
              bisque: 16770244,
              black: 0,
              blanchedalmond: 16772045,
              blue: 255,
              blueviolet: 9055202,
              brown: 10824234,
              burlywood: 14596231,
              cadetblue: 6266528,
              chartreuse: 8388352,
              chocolate: 13789470,
              coral: 16744272,
              cornflowerblue: 6591981,
              cornsilk: 16775388,
              crimson: 14423100,
              cyan: 65535,
              darkblue: 139,
              darkcyan: 35723,
              darkgoldenrod: 12092939,
              darkgray: 11119017,
              darkgreen: 25600,
              darkgrey: 11119017,
              darkkhaki: 12433259,
              darkmagenta: 9109643,
              darkolivegreen: 5597999,
              darkorange: 16747520,
              darkorchid: 10040012,
              darkred: 9109504,
              darksalmon: 15308410,
              darkseagreen: 9419919,
              darkslateblue: 4734347,
              darkslategray: 3100495,
              darkslategrey: 3100495,
              darkturquoise: 52945,
              darkviolet: 9699539,
              deeppink: 16716947,
              deepskyblue: 49151,
              dimgray: 6908265,
              dimgrey: 6908265,
              dodgerblue: 2003199,
              firebrick: 11674146,
              floralwhite: 16775920,
              forestgreen: 2263842,
              fuchsia: 16711935,
              gainsboro: 14474460,
              ghostwhite: 16316671,
              gold: 16766720,
              goldenrod: 14329120,
              gray: 8421504,
              green: 32768,
              greenyellow: 11403055,
              grey: 8421504,
              honeydew: 15794160,
              hotpink: 16738740,
              indianred: 13458524,
              indigo: 4915330,
              ivory: 16777200,
              khaki: 15787660,
              lavender: 15132410,
              lavenderblush: 16773365,
              lawngreen: 8190976,
              lemonchiffon: 16775885,
              lightblue: 11393254,
              lightcoral: 15761536,
              lightcyan: 14745599,
              lightgoldenrodyellow: 16448210,
              lightgray: 13882323,
              lightgreen: 9498256,
              lightgrey: 13882323,
              lightpink: 16758465,
              lightsalmon: 16752762,
              lightseagreen: 2142890,
              lightskyblue: 8900346,
              lightslategray: 7833753,
              lightslategrey: 7833753,
              lightsteelblue: 11584734,
              lightyellow: 16777184,
              lime: 65280,
              limegreen: 3329330,
              linen: 16445670,
              magenta: 16711935,
              maroon: 8388608,
              mediumaquamarine: 6737322,
              mediumblue: 205,
              mediumorchid: 12211667,
              mediumpurple: 9662683,
              mediumseagreen: 3978097,
              mediumslateblue: 8087790,
              mediumspringgreen: 64154,
              mediumturquoise: 4772300,
              mediumvioletred: 13047173,
              midnightblue: 1644912,
              mintcream: 16121850,
              mistyrose: 16770273,
              moccasin: 16770229,
              navajowhite: 16768685,
              navy: 128,
              oldlace: 16643558,
              olive: 8421376,
              olivedrab: 7048739,
              orange: 16753920,
              orangered: 16729344,
              orchid: 14315734,
              palegoldenrod: 15657130,
              palegreen: 10025880,
              paleturquoise: 11529966,
              palevioletred: 14381203,
              papayawhip: 16773077,
              peachpuff: 16767673,
              peru: 13468991,
              pink: 16761035,
              plum: 14524637,
              powderblue: 11591910,
              purple: 8388736,
              rebeccapurple: 6697881,
              red: 16711680,
              rosybrown: 12357519,
              royalblue: 4286945,
              saddlebrown: 9127187,
              salmon: 16416882,
              sandybrown: 16032864,
              seagreen: 3050327,
              seashell: 16774638,
              sienna: 10506797,
              silver: 12632256,
              skyblue: 8900331,
              slateblue: 6970061,
              slategray: 7372944,
              slategrey: 7372944,
              snow: 16775930,
              springgreen: 65407,
              steelblue: 4620980,
              tan: 13808780,
              teal: 32896,
              thistle: 14204888,
              tomato: 16737095,
              turquoise: 4251856,
              violet: 15631086,
              wheat: 16113331,
              white: 16777215,
              whitesmoke: 16119285,
              yellow: 16776960,
              yellowgreen: 10145074,
            };
          lt(j, B, {
            copy: function (t) {
              return Object.assign(new this.constructor(), this, t);
            },
            displayable: function () {
              return this.rgb().displayable();
            },
            hex: qt,
            formatHex: qt,
            formatHsl: En,
            formatRgb: It,
            toString: It,
          });
          function qt() {
            return this.rgb().formatHex();
          }
          function En() {
            return jt(this).formatHsl();
          }
          function It() {
            return this.rgb().formatRgb();
          }
          function B(t) {
            var n, e;
            return (
              (t = (t + '').trim().toLowerCase()),
              (n = Mn.exec(t))
                ? ((e = n[1].length),
                  (n = parseInt(n[1], 16)),
                  e === 6
                    ? zt(n)
                    : e === 3
                      ? new g(
                          ((n >> 8) & 15) | ((n >> 4) & 240),
                          ((n >> 4) & 15) | (n & 240),
                          ((n & 15) << 4) | (n & 15),
                          1,
                        )
                      : e === 8
                        ? new g((n >> 24) & 255, (n >> 16) & 255, (n >> 8) & 255, (n & 255) / 255)
                        : e === 4
                          ? new g(
                              ((n >> 12) & 15) | ((n >> 8) & 240),
                              ((n >> 8) & 15) | ((n >> 4) & 240),
                              ((n >> 4) & 15) | (n & 240),
                              (((n & 15) << 4) | (n & 15)) / 255,
                            )
                          : null)
                : (n = _n.exec(t))
                  ? new g(n[1], n[2], n[3], 1)
                  : (n = Nn.exec(t))
                    ? new g((n[1] * 255) / 100, (n[2] * 255) / 100, (n[3] * 255) / 100, 1)
                    : (n = kn.exec(t))
                      ? Ct(n[1], n[2], n[3], n[4])
                      : (n = An.exec(t))
                        ? Ct((n[1] * 255) / 100, (n[2] * 255) / 100, (n[3] * 255) / 100, n[4])
                        : (n = Sn.exec(t))
                          ? Ht(n[1], n[2] / 100, n[3] / 100, 1)
                          : (n = Rn.exec(t))
                            ? Ht(n[1], n[2] / 100, n[3] / 100, n[4])
                            : $t.hasOwnProperty(t)
                              ? zt($t[t])
                              : t === 'transparent'
                                ? new g(NaN, NaN, NaN, 0)
                                : null
            );
          }
          function zt(t) {
            return new g((t >> 16) & 255, (t >> 8) & 255, t & 255, 1);
          }
          function Ct(t, n, e, r) {
            return r <= 0 && (t = n = e = NaN), new g(t, n, e, r);
          }
          function Pn(t) {
            return t instanceof j || (t = B(t)), t ? ((t = t.rgb()), new g(t.r, t.g, t.b, t.opacity)) : new g();
          }
          function dt(t, n, e, r) {
            return arguments.length === 1 ? Pn(t) : new g(t, n, e, r ?? 1);
          }
          function g(t, n, e, r) {
            (this.r = +t), (this.g = +n), (this.b = +e), (this.opacity = +r);
          }
          lt(
            g,
            dt,
            Tt(j, {
              brighter: function (t) {
                return (t = t == null ? Z : Math.pow(Z, t)), new g(this.r * t, this.g * t, this.b * t, this.opacity);
              },
              darker: function (t) {
                return (t = t == null ? F : Math.pow(F, t)), new g(this.r * t, this.g * t, this.b * t, this.opacity);
              },
              rgb: function () {
                return this;
              },
              displayable: function () {
                return (
                  -0.5 <= this.r &&
                  this.r < 255.5 &&
                  -0.5 <= this.g &&
                  this.g < 255.5 &&
                  -0.5 <= this.b &&
                  this.b < 255.5 &&
                  0 <= this.opacity &&
                  this.opacity <= 1
                );
              },
              hex: Lt,
              formatHex: Lt,
              formatRgb: Ot,
              toString: Ot,
            }),
          );
          function Lt() {
            return '#' + gt(this.r) + gt(this.g) + gt(this.b);
          }
          function Ot() {
            var t = this.opacity;
            return (
              (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))),
              (t === 1 ? 'rgb(' : 'rgba(') +
                Math.max(0, Math.min(255, Math.round(this.r) || 0)) +
                ', ' +
                Math.max(0, Math.min(255, Math.round(this.g) || 0)) +
                ', ' +
                Math.max(0, Math.min(255, Math.round(this.b) || 0)) +
                (t === 1 ? ')' : ', ' + t + ')')
            );
          }
          function gt(t) {
            return (t = Math.max(0, Math.min(255, Math.round(t) || 0))), (t < 16 ? '0' : '') + t.toString(16);
          }
          function Ht(t, n, e, r) {
            return (
              r <= 0 ? (t = n = e = NaN) : e <= 0 || e >= 1 ? (t = n = NaN) : n <= 0 && (t = NaN), new N(t, n, e, r)
            );
          }
          function jt(t) {
            if (t instanceof N) return new N(t.h, t.s, t.l, t.opacity);
            if ((t instanceof j || (t = B(t)), !t)) return new N();
            if (t instanceof N) return t;
            t = t.rgb();
            var n = t.r / 255,
              e = t.g / 255,
              r = t.b / 255,
              i = Math.min(n, e, r),
              a = Math.max(n, e, r),
              f = NaN,
              o = a - i,
              u = (a + i) / 2;
            return (
              o
                ? (n === a ? (f = (e - r) / o + (e < r) * 6) : e === a ? (f = (r - n) / o + 2) : (f = (n - e) / o + 4),
                  (o /= u < 0.5 ? a + i : 2 - a - i),
                  (f *= 60))
                : (o = u > 0 && u < 1 ? 0 : f),
              new N(f, o, u, t.opacity)
            );
          }
          function Tn(t, n, e, r) {
            return arguments.length === 1 ? jt(t) : new N(t, n, e, r ?? 1);
          }
          function N(t, n, e, r) {
            (this.h = +t), (this.s = +n), (this.l = +e), (this.opacity = +r);
          }
          lt(
            N,
            Tn,
            Tt(j, {
              brighter: function (t) {
                return (t = t == null ? Z : Math.pow(Z, t)), new N(this.h, this.s, this.l * t, this.opacity);
              },
              darker: function (t) {
                return (t = t == null ? F : Math.pow(F, t)), new N(this.h, this.s, this.l * t, this.opacity);
              },
              rgb: function () {
                var t = (this.h % 360) + (this.h < 0) * 360,
                  n = isNaN(t) || isNaN(this.s) ? 0 : this.s,
                  e = this.l,
                  r = e + (e < 0.5 ? e : 1 - e) * n,
                  i = 2 * e - r;
                return new g(
                  xt(t >= 240 ? t - 240 : t + 120, i, r),
                  xt(t, i, r),
                  xt(t < 120 ? t + 240 : t - 120, i, r),
                  this.opacity,
                );
              },
              displayable: function () {
                return (
                  ((0 <= this.s && this.s <= 1) || isNaN(this.s)) &&
                  0 <= this.l &&
                  this.l <= 1 &&
                  0 <= this.opacity &&
                  this.opacity <= 1
                );
              },
              formatHsl: function () {
                var t = this.opacity;
                return (
                  (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))),
                  (t === 1 ? 'hsl(' : 'hsla(') +
                    (this.h || 0) +
                    ', ' +
                    (this.s || 0) * 100 +
                    '%, ' +
                    (this.l || 0) * 100 +
                    '%' +
                    (t === 1 ? ')' : ', ' + t + ')')
                );
              },
            }),
          );
          function xt(t, n, e) {
            return (t < 60 ? n + ((e - n) * t) / 60 : t < 180 ? e : t < 240 ? n + ((e - n) * (240 - t)) / 60 : n) * 255;
          }
          function mt(t) {
            return function () {
              return t;
            };
          }
          function $n(t, n) {
            return function (e) {
              return t + e * n;
            };
          }
          function qn(t, n, e) {
            return (
              (t = Math.pow(t, e)),
              (n = Math.pow(n, e) - t),
              (e = 1 / e),
              function (r) {
                return Math.pow(t + r * n, e);
              }
            );
          }
          function In(t) {
            return (t = +t) == 1
              ? Ft
              : function (n, e) {
                  return e - n ? qn(n, e, t) : mt(isNaN(n) ? e : n);
                };
          }
          function Ft(t, n) {
            var e = n - t;
            return e ? $n(t, e) : mt(isNaN(t) ? n : t);
          }
          var Dt = (function t(n) {
            var e = In(n);
            function r(i, a) {
              var f = e((i = dt(i)).r, (a = dt(a)).r),
                o = e(i.g, a.g),
                u = e(i.b, a.b),
                d = Ft(i.opacity, a.opacity);
              return function (c) {
                return (i.r = f(c)), (i.g = o(c)), (i.b = u(c)), (i.opacity = d(c)), i + '';
              };
            }
            return (r.gamma = t), r;
          })(1);
          function zn(t, n) {
            n || (n = []);
            var e = t ? Math.min(n.length, t.length) : 0,
              r = n.slice(),
              i;
            return function (a) {
              for (i = 0; i < e; ++i) r[i] = t[i] * (1 - a) + n[i] * a;
              return r;
            };
          }
          function Cn(t) {
            return ArrayBuffer.isView(t) && !(t instanceof DataView);
          }
          function Ln(t, n) {
            var e = n ? n.length : 0,
              r = t ? Math.min(e, t.length) : 0,
              i = new Array(r),
              a = new Array(e),
              f;
            for (f = 0; f < r; ++f) i[f] = bt(t[f], n[f]);
            for (; f < e; ++f) a[f] = n[f];
            return function (o) {
              for (f = 0; f < r; ++f) a[f] = i[f](o);
              return a;
            };
          }
          function On(t, n) {
            var e = new Date();
            return (
              (t = +t),
              (n = +n),
              function (r) {
                return e.setTime(t * (1 - r) + n * r), e;
              }
            );
          }
          function U(t, n) {
            return (
              (t = +t),
              (n = +n),
              function (e) {
                return t * (1 - e) + n * e;
              }
            );
          }
          function Hn(t, n) {
            var e = {},
              r = {},
              i;
            (t === null || typeof t != 'object') && (t = {}), (n === null || typeof n != 'object') && (n = {});
            for (i in n) i in t ? (e[i] = bt(t[i], n[i])) : (r[i] = n[i]);
            return function (a) {
              for (i in e) r[i] = e[i](a);
              return r;
            };
          }
          var pt = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
            yt = new RegExp(pt.source, 'g');
          function jn(t) {
            return function () {
              return t;
            };
          }
          function Fn(t) {
            return function (n) {
              return t(n) + '';
            };
          }
          function Dn(t, n) {
            var e = (pt.lastIndex = yt.lastIndex = 0),
              r,
              i,
              a,
              f = -1,
              o = [],
              u = [];
            for (t = t + '', n = n + ''; (r = pt.exec(t)) && (i = yt.exec(n)); )
              (a = i.index) > e && ((a = n.slice(e, a)), o[f] ? (o[f] += a) : (o[++f] = a)),
                (r = r[0]) === (i = i[0])
                  ? o[f]
                    ? (o[f] += i)
                    : (o[++f] = i)
                  : ((o[++f] = null), u.push({ i: f, x: U(r, i) })),
                (e = yt.lastIndex);
            return (
              e < n.length && ((a = n.slice(e)), o[f] ? (o[f] += a) : (o[++f] = a)),
              o.length < 2
                ? u[0]
                  ? Fn(u[0].x)
                  : jn(n)
                : ((n = u.length),
                  function (d) {
                    for (var c = 0, s; c < n; ++c) o[(s = u[c]).i] = s.x(d);
                    return o.join('');
                  })
            );
          }
          function bt(t, n) {
            var e = typeof n,
              r;
            return n == null || e === 'boolean'
              ? mt(n)
              : (e === 'number'
                  ? U
                  : e === 'string'
                    ? (r = B(n))
                      ? ((n = r), Dt)
                      : Dn
                    : n instanceof B
                      ? Dt
                      : n instanceof Date
                        ? On
                        : Cn(n)
                          ? zn
                          : Array.isArray(n)
                            ? Ln
                            : (typeof n.valueOf != 'function' && typeof n.toString != 'function') || isNaN(n)
                              ? Hn
                              : U)(t, n);
          }
          function Bn(t, n) {
            return (
              (t = +t),
              (n = +n),
              function (e) {
                return Math.round(t * (1 - e) + n * e);
              }
            );
          }
          function Gn(t) {
            return function () {
              return t;
            };
          }
          function Vn(t) {
            return +t;
          }
          var Bt = [0, 1];
          function C(t) {
            return t;
          }
          function vt(t, n) {
            return (n -= t = +t)
              ? function (e) {
                  return (e - t) / n;
                }
              : Gn(isNaN(n) ? NaN : 0.5);
          }
          function Gt(t) {
            var n = t[0],
              e = t[t.length - 1],
              r;
            return (
              n > e && ((r = n), (n = e), (e = r)),
              function (i) {
                return Math.max(n, Math.min(e, i));
              }
            );
          }
          function Xn(t, n, e) {
            var r = t[0],
              i = t[1],
              a = n[0],
              f = n[1];
            return (
              i < r ? ((r = vt(i, r)), (a = e(f, a))) : ((r = vt(r, i)), (a = e(a, f))),
              function (o) {
                return a(r(o));
              }
            );
          }
          function Zn(t, n, e) {
            var r = Math.min(t.length, n.length) - 1,
              i = new Array(r),
              a = new Array(r),
              f = -1;
            for (t[r] < t[0] && ((t = t.slice().reverse()), (n = n.slice().reverse())); ++f < r; )
              (i[f] = vt(t[f], t[f + 1])), (a[f] = e(n[f], n[f + 1]));
            return function (o) {
              var u = pn(t, o, 1, r) - 1;
              return a[u](i[u](o));
            };
          }
          function Un(t, n) {
            return n
              .domain(t.domain())
              .range(t.range())
              .interpolate(t.interpolate())
              .clamp(t.clamp())
              .unknown(t.unknown());
          }
          function Wn() {
            var t = Bt,
              n = Bt,
              e = bt,
              r,
              i,
              a,
              f = C,
              o,
              u,
              d;
            function c() {
              return (o = Math.min(t.length, n.length) > 2 ? Zn : Xn), (u = d = null), s;
            }
            function s(h) {
              return isNaN((h = +h)) ? a : (u || (u = o(t.map(r), n, e)))(r(f(h)));
            }
            return (
              (s.invert = function (h) {
                return f(i((d || (d = o(n, t.map(r), U)))(h)));
              }),
              (s.domain = function (h) {
                return arguments.length ? ((t = wn.call(h, Vn)), f === C || (f = Gt(t)), c()) : t.slice();
              }),
              (s.range = function (h) {
                return arguments.length ? ((n = Pt.call(h)), c()) : n.slice();
              }),
              (s.rangeRound = function (h) {
                return (n = Pt.call(h)), (e = Bn), c();
              }),
              (s.clamp = function (h) {
                return arguments.length ? ((f = h ? Gt(t) : C), s) : f !== C;
              }),
              (s.interpolate = function (h) {
                return arguments.length ? ((e = h), c()) : e;
              }),
              (s.unknown = function (h) {
                return arguments.length ? ((a = h), s) : a;
              }),
              function (h, y) {
                return (r = h), (i = y), c();
              }
            );
          }
          function Yn(t, n) {
            return Wn()(t, n);
          }
          function W(t, n) {
            if ((e = (t = n ? t.toExponential(n - 1) : t.toExponential()).indexOf('e')) < 0) return null;
            var e,
              r = t.slice(0, e);
            return [r.length > 1 ? r[0] + r.slice(2) : r, +t.slice(e + 1)];
          }
          function L(t) {
            return (t = W(Math.abs(t))), t ? t[1] : NaN;
          }
          function Qn(t, n) {
            return function (e, r) {
              for (
                var i = e.length, a = [], f = 0, o = t[0], u = 0;
                i > 0 &&
                o > 0 &&
                (u + o + 1 > r && (o = Math.max(1, r - u)), a.push(e.substring((i -= o), i + o)), !((u += o + 1) > r));

              )
                o = t[(f = (f + 1) % t.length)];
              return a.reverse().join(n);
            };
          }
          function Jn(t) {
            return function (n) {
              return n.replace(/[0-9]/g, function (e) {
                return t[+e];
              });
            };
          }
          var Kn = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
          function Y(t) {
            if (!(n = Kn.exec(t))) throw new Error('invalid format: ' + t);
            var n;
            return new wt({
              fill: n[1],
              align: n[2],
              sign: n[3],
              symbol: n[4],
              zero: n[5],
              width: n[6],
              comma: n[7],
              precision: n[8] && n[8].slice(1),
              trim: n[9],
              type: n[10],
            });
          }
          Y.prototype = wt.prototype;
          function wt(t) {
            (this.fill = t.fill === void 0 ? ' ' : t.fill + ''),
              (this.align = t.align === void 0 ? '>' : t.align + ''),
              (this.sign = t.sign === void 0 ? '-' : t.sign + ''),
              (this.symbol = t.symbol === void 0 ? '' : t.symbol + ''),
              (this.zero = !!t.zero),
              (this.width = t.width === void 0 ? void 0 : +t.width),
              (this.comma = !!t.comma),
              (this.precision = t.precision === void 0 ? void 0 : +t.precision),
              (this.trim = !!t.trim),
              (this.type = t.type === void 0 ? '' : t.type + '');
          }
          wt.prototype.toString = function () {
            return (
              this.fill +
              this.align +
              this.sign +
              this.symbol +
              (this.zero ? '0' : '') +
              (this.width === void 0 ? '' : Math.max(1, this.width | 0)) +
              (this.comma ? ',' : '') +
              (this.precision === void 0 ? '' : '.' + Math.max(0, this.precision | 0)) +
              (this.trim ? '~' : '') +
              this.type
            );
          };
          function te(t) {
            t: for (var n = t.length, e = 1, r = -1, i; e < n; ++e)
              switch (t[e]) {
                case '.':
                  r = i = e;
                  break;
                case '0':
                  r === 0 && (r = e), (i = e);
                  break;
                default:
                  if (!+t[e]) break t;
                  r > 0 && (r = 0);
                  break;
              }
            return r > 0 ? t.slice(0, r) + t.slice(i + 1) : t;
          }
          var Vt;
          function ne(t, n) {
            var e = W(t, n);
            if (!e) return t + '';
            var r = e[0],
              i = e[1],
              a = i - (Vt = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1,
              f = r.length;
            return a === f
              ? r
              : a > f
                ? r + new Array(a - f + 1).join('0')
                : a > 0
                  ? r.slice(0, a) + '.' + r.slice(a)
                  : '0.' + new Array(1 - a).join('0') + W(t, Math.max(0, n + a - 1))[0];
          }
          function Xt(t, n) {
            var e = W(t, n);
            if (!e) return t + '';
            var r = e[0],
              i = e[1];
            return i < 0
              ? '0.' + new Array(-i).join('0') + r
              : r.length > i + 1
                ? r.slice(0, i + 1) + '.' + r.slice(i + 1)
                : r + new Array(i - r.length + 2).join('0');
          }
          var Zt = {
            '%': function (t, n) {
              return (t * 100).toFixed(n);
            },
            b: function (t) {
              return Math.round(t).toString(2);
            },
            c: function (t) {
              return t + '';
            },
            d: function (t) {
              return Math.round(t).toString(10);
            },
            e: function (t, n) {
              return t.toExponential(n);
            },
            f: function (t, n) {
              return t.toFixed(n);
            },
            g: function (t, n) {
              return t.toPrecision(n);
            },
            o: function (t) {
              return Math.round(t).toString(8);
            },
            p: function (t, n) {
              return Xt(t * 100, n);
            },
            r: Xt,
            s: ne,
            X: function (t) {
              return Math.round(t).toString(16).toUpperCase();
            },
            x: function (t) {
              return Math.round(t).toString(16);
            },
          };
          function Ut(t) {
            return t;
          }
          var Wt = Array.prototype.map,
            Yt = ['y', 'z', 'a', 'f', 'p', 'n', 'µ', 'm', '', 'k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
          function ee(t) {
            var n =
                t.grouping === void 0 || t.thousands === void 0
                  ? Ut
                  : Qn(Wt.call(t.grouping, Number), t.thousands + ''),
              e = t.currency === void 0 ? '' : t.currency[0] + '',
              r = t.currency === void 0 ? '' : t.currency[1] + '',
              i = t.decimal + '',
              a = t.numerals === void 0 ? Ut : Jn(Wt.call(t.numerals, String)),
              f = t.percent === void 0 ? '%' : t.percent + '',
              o = t.minus + '',
              u = t.nan === void 0 ? 'NaN' : t.nan + '';
            function d(s) {
              s = Y(s);
              var h = s.fill,
                y = s.align,
                x = s.sign,
                m = s.symbol,
                M = s.zero,
                k = s.width,
                E = s.comma,
                b = s.precision,
                $ = s.trim,
                p = s.type;
              p === 'n' ? ((E = !0), (p = 'g')) : Zt[p] || (b === void 0 && (b = 12), ($ = !0), (p = 'g')),
                (M || (h === '0' && y === '=')) && ((M = !0), (h = '0'), (y = '='));
              var J = m === '$' ? e : m === '#' && /[boxX]/.test(p) ? '0' + p.toLowerCase() : '',
                ce = m === '$' ? r : /[%p]/.test(p) ? f : '',
                Kt = Zt[p],
                le = /[defgprs%]/.test(p);
              b = b === void 0 ? 6 : /[gprs]/.test(p) ? Math.max(1, Math.min(21, b)) : Math.max(0, Math.min(20, b));
              function tn(l) {
                var q = J,
                  w = ce,
                  O,
                  nn,
                  K;
                if (p === 'c') (w = Kt(l) + w), (l = '');
                else {
                  l = +l;
                  var tt = l < 0;
                  if (
                    ((l = isNaN(l) ? u : Kt(Math.abs(l), b)),
                    $ && (l = te(l)),
                    tt && +l == 0 && (tt = !1),
                    (q = (tt ? (x === '(' ? x : o) : x === '-' || x === '(' ? '' : x) + q),
                    (w = (p === 's' ? Yt[8 + Vt / 3] : '') + w + (tt && x === '(' ? ')' : '')),
                    le)
                  ) {
                    for (O = -1, nn = l.length; ++O < nn; )
                      if (((K = l.charCodeAt(O)), 48 > K || K > 57)) {
                        (w = (K === 46 ? i + l.slice(O + 1) : l.slice(O)) + w), (l = l.slice(0, O));
                        break;
                      }
                  }
                }
                E && !M && (l = n(l, 1 / 0));
                var nt = q.length + l.length + w.length,
                  R = nt < k ? new Array(k - nt + 1).join(h) : '';
                switch ((E && M && ((l = n(R + l, R.length ? k - w.length : 1 / 0)), (R = '')), y)) {
                  case '<':
                    l = q + l + w + R;
                    break;
                  case '=':
                    l = q + R + l + w;
                    break;
                  case '^':
                    l = R.slice(0, (nt = R.length >> 1)) + q + l + w + R.slice(nt);
                    break;
                  default:
                    l = R + q + l + w;
                    break;
                }
                return a(l);
              }
              return (
                (tn.toString = function () {
                  return s + '';
                }),
                tn
              );
            }
            function c(s, h) {
              var y = d(((s = Y(s)), (s.type = 'f'), s)),
                x = Math.max(-8, Math.min(8, Math.floor(L(h) / 3))) * 3,
                m = Math.pow(10, -x),
                M = Yt[8 + x / 3];
              return function (k) {
                return y(m * k) + M;
              };
            }
            return { format: d, formatPrefix: c };
          }
          var Q, Qt, Jt;
          re({ decimal: '.', thousands: ',', grouping: [3], currency: ['$', ''], minus: '-' });
          function re(t) {
            return (Q = ee(t)), (Qt = Q.format), (Jt = Q.formatPrefix), Q;
          }
          function ie(t) {
            return Math.max(0, -L(Math.abs(t)));
          }
          function ae(t, n) {
            return Math.max(0, Math.max(-8, Math.min(8, Math.floor(L(n) / 3))) * 3 - L(Math.abs(t)));
          }
          function fe(t, n) {
            return (t = Math.abs(t)), (n = Math.abs(n) - t), Math.max(0, L(n) - L(t)) + 1;
          }
          function oe(t, n, e, r) {
            var i = bn(t, n, e),
              a;
            switch (((r = Y(r ?? ',f')), r.type)) {
              case 's': {
                var f = Math.max(Math.abs(t), Math.abs(n));
                return r.precision == null && !isNaN((a = ae(i, f))) && (r.precision = a), Jt(r, f);
              }
              case '':
              case 'e':
              case 'g':
              case 'p':
              case 'r': {
                r.precision == null &&
                  !isNaN((a = fe(i, Math.max(Math.abs(t), Math.abs(n))))) &&
                  (r.precision = a - (r.type === 'e'));
                break;
              }
              case 'f':
              case '%': {
                r.precision == null && !isNaN((a = ie(i))) && (r.precision = a - (r.type === '%') * 2);
                break;
              }
            }
            return Qt(r);
          }
          function ue(t) {
            var n = t.domain;
            return (
              (t.ticks = function (e) {
                var r = n();
                return yn(r[0], r[r.length - 1], e ?? 10);
              }),
              (t.tickFormat = function (e, r) {
                var i = n();
                return oe(i[0], i[i.length - 1], e ?? 10, r);
              }),
              (t.nice = function (e) {
                e == null && (e = 10);
                var r = n(),
                  i = 0,
                  a = r.length - 1,
                  f = r[i],
                  o = r[a],
                  u;
                return (
                  o < f && ((u = f), (f = o), (o = u), (u = i), (i = a), (a = u)),
                  (u = V(f, o, e)),
                  u > 0
                    ? ((f = Math.floor(f / u) * u), (o = Math.ceil(o / u) * u), (u = V(f, o, e)))
                    : u < 0 && ((f = Math.ceil(f * u) / u), (o = Math.floor(o * u) / u), (u = V(f, o, e))),
                  u > 0
                    ? ((r[i] = Math.floor(f / u) * u), (r[a] = Math.ceil(o / u) * u), n(r))
                    : u < 0 && ((r[i] = Math.ceil(f * u) / u), (r[a] = Math.floor(o * u) / u), n(r)),
                  t
                );
              }),
              t
            );
          }
          function Mt() {
            var t = Yn(C, C);
            return (
              (t.copy = function () {
                return Un(t, Mt());
              }),
              vn.apply(t, arguments),
              ue(t)
            );
          }
          var se = function t(n) {
              var e = n.height,
                r = n.path,
                i = n.threshold,
                a = i === void 0 ? 0.2 : i,
                f = n.width;
              H(this, t),
                he.call(this),
                (this.height = e),
                (this.path = r),
                (this.threshold = a),
                (this.width = f),
                (this.aspect_ratio = f / e),
                (this.path_data = this.convertPathToData(r)),
                (this.maximums = this.getMaximums(this.path_data)),
                (this.range_ratios = this.getRatios(this.maximums, f, e));
            },
            he = function () {
              var n = this;
              (this.getMaximums = function (e) {
                var r = e.map(function (a) {
                    return a[0];
                  }),
                  i = e.map(function (a) {
                    return a[1];
                  });
                return [Math.max.apply(Math, rt(r)), Math.max.apply(Math, rt(i))];
              }),
                (this.getRatios = function (e, r, i) {
                  return [e[0] / r, e[1] / i];
                }),
                (this.convertPathToData = function (e) {
                  var r = document.createElement('div');
                  r.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg">
                                  <path d="`.concat(
                    e,
                    `"/>
                                </svg>`,
                  );
                  for (var i = r.querySelector('path'), a = [], f = 0; f < i.getTotalLength(); f++) {
                    var o = i.getPointAtLength(f),
                      u = o.x,
                      d = o.y;
                    a.push([u, d]);
                  }
                  return a;
                }),
                (this.generatePath = function (e, r) {
                  var i = n.height,
                    a = n.width,
                    f = n.aspect_ratio,
                    o = n.path_data,
                    u = I(n.maximums, 2),
                    d = u[0],
                    c = u[1],
                    s = I(n.range_ratios, 2),
                    h = s[0],
                    y = s[1],
                    x = n.threshold,
                    m = [0, 0],
                    M = e / r;
                  if (Math.abs(M - f) > x)
                    if (a < i) {
                      var k = (i - a) / i;
                      m[0] = (k * e) / 2;
                    } else {
                      var E = (a - i) / a;
                      m[1] = (E * r) / 2;
                    }
                  var b = Mt()
                      .domain([0, d])
                      .range([m[0], e * h - m[0]]),
                    $ = Mt()
                      .domain([0, c])
                      .range([m[1], r * y - m[1]]),
                    p = o.map(function (J) {
                      return [b(J[0]), $(J[1])];
                    });
                  return dn()(p);
                });
            };
          return se;
        });
      })(et)),
    et.exports
  );
}
var me = xe();
const pe = de(me);
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-flight-path]').forEach((S) => {
    A(S);
  });
  function A(S) {
    let H = S.querySelector('svg').getAttribute('viewBox').replace('0 0 ', '').split(' '),
      I = new pe({ path: S.querySelector('path').getAttribute('d'), width: H[0], height: H[1] });
    new ResizeObserver(() => {
      const it = I.generatePath(S.offsetWidth, S.offsetHeight);
      S.style.setProperty('--path', `"${it}"`);
    }).observe(S);
  }
});
